import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ConnectionStateService } from './connection-state.service';

@Injectable()
export class ConnectionStateInterceptor implements HttpInterceptor {
  constructor(private connection: ConnectionStateService) { }
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const response = next.handle(request);
    return request.url.startsWith(environment.API_BASE_URL + '/') ? this.connection.track(response) : response;
  }
}
